import { createContext, useContext, useEffect, useState } from "react";
import api, { setToken, clearToken, errText } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=user
  const [ready, setReady] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        setUser(false);
      } finally {
        setReady(true);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.token);
    setUser(data.user);
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setToken(data.token);
    setUser(data.user);
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    clearToken();
    localStorage.removeItem("equiro_stable");
    localStorage.removeItem("equiro_assist");
    setUser(false);
  };

  const updatePreferences = async (prefs) => {
    try {
      const { data } = await api.put("/auth/preferences", { preferences: prefs });
      setUser((u) => (u ? { ...u, preferences: data.preferences } : u));
    } catch { /* noop */ }
  };

  const refreshUser = async () => {
    try { const { data } = await api.get("/auth/me"); setUser(data); return data; }
    catch { return null; }
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, register, logout, updatePreferences, refreshUser, errText }}>
      {children}
    </AuthContext.Provider>
  );
}
